<template>
  <div class="content-wrapper bg-white dark:bg-darkblue-900 flex flex-col w-full relative overflow-hidden">
    <slot name="header" />
    <main class="content flex flex-col flex-auto overflow-y-auto w-full">
      <div class="w-full md:w-11.5/12">
        <div class="px-4 lg:px-10">
            <slot name="main" />
        </div>
      </div>
    </main>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail-full-width'
}
</script>
